import PartyRelationship from '@/axios/party-relationship-endpoint'

export const utils = {
  methods: {
    async getAllSettled (promises, returnErrors = false) {
      const rejected = []
      const results = await Promise.allSettled(promises)
      const fulfilled = results.flatMap(result => {
        if (result.status === 'rejected') {
          rejected.push(result)
          return []
        }
        return result.value
      })
      if (rejected.length > 0) console.log('Rejected promises:', rejected)
      if (returnErrors) {
        return { fulfilled, rejected }
      }
      return fulfilled
    },
    calcEffectiveCost (item, promo) {
      let effectiveCost = ''
      const effectiveFutureCostDate = this.$auth.tenant === 'pricechopper' ? promo.start_dt : promo.end_dt
      effectiveCost = item.future_cost_date <= effectiveFutureCostDate ? item.future_cost : item.cost
      return effectiveCost
    },
    formatItemPrices (item, formatFields = ['sale_price', 'cost', 'effective_cost', 'future_cost']) {
      for (const field of formatFields) {
        item[field] = this.getFormattedPrice(item[field])
      }
      return item
    },
    formatCurrencyDisplay (value) {
      return parseFloat(value).toFixed(2)
    },
    getFormattedPrice (value) {
      return (value != null) ? `$${this.$config.formatCurrency(this.getNumericPrice(value))}` : value
    },
    getNumericPrice (value) {
      if (typeof value === 'string' && value.includes('$')) {
        value = value.replace('$', '')
      }
      value = Number(value)
      return Number.isNaN(value) ? 0 : value
    },
    getFormattedGroup (group, isAccrualPromo) {
      const priceFields = [
        'retail_price', 'promotion_price', 'rebate_amount',
        'variance', 'amap_allowance', 'early_buy_allowance', 'billback_allowance'
      ]
      for (const field of priceFields) {
        const val = group[field]
        if (field === 'billback_allowance' && isAccrualPromo) {
          if (group.allowance_amt_type?.toLowerCase() !== 'case') continue
        }
        group[field] = this.$config.formatCurrency(val)
      }
      return group
    },
    sortByKey (arr, key) {
      arr.sort((a, b) => {
        if (a && b) {
          if (a[key] < b[key]) return -1
          else if (a[key] > b[key]) return 1
          else return 0
        }
      })
      return arr
    },
    async getMemberPartyIds (party, memberPartyTypes = []) {
      let partyIds = []
      const partyId = party.party_id || party.store_id
      const isRegionGroup = (party?.party_type === 'REGION_GROUP')
        || (party?.party_type_name?.toLowerCase() === 'region group')
      const isDistributionCenter = (party?.party_type === 'DISTRIBUTION_CENTER')
        || (party?.party_type_name?.toLowerCase() === 'distribution center')
      const memberTypes = this.$auth.tenant === 'alliance-retail-group' && isDistributionCenter ? ['AD_GROUP'] : memberPartyTypes
      const relParty = isRegionGroup ? 'to_party' : 'from_party'

      const generator = PartyRelationship.genPartyRelationships(partyId, 0, 200, true)
        for await (const results of generator) {
          if (results?.length > 0) {
            const ids = results.flatMap(rel => {
              if (memberTypes.includes(rel[relParty]?.party_type?.constant)) {
                return rel[relParty].id
              }
              return []
            })
            partyIds.push(...ids)
          }
        }

      if (this.limitAccessByRelatedStores && (isRegionGroup || (this.$auth.tenant === 'alliance-retail-group' && isDistributionCenter))) {
        partyIds = partyIds.filter(id => this.userRelatedPartyIds.includes(id))
      }
      if (this.$auth.tenant === 'alliance-retail-group' && isDistributionCenter) {
        const dc = this.$store.getters.activeDistributionCenters.find(ag => ag.id === partyId)
        partyIds = partyIds.filter(id => this.activeAdGroups.some(active_ag => (id === active_ag.id) && dc.member_ids.includes(active_ag.id)))
      }
      return partyIds
    }
  },
  computed: {
    activeAdGroups () {
      let groups = this.$store.getters.adGroups.filter((g) => g?.attributes?.AD_GROUP_IS_ACTIVE === 'True')
      if (this.limitAccessByRelatedStores) {
        groups = groups.filter(g => this.userRelatedPartyIds.includes(g.id))
      }
      return this.sortByKey(groups, 'name')
    }
  }
}